"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendToAll = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EVoyageCrewCreateMethod = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var EVoyageCrewCreateMethod;
(function (EVoyageCrewCreateMethod) {
    EVoyageCrewCreateMethod[EVoyageCrewCreateMethod["Normal"] = 0] = "Normal";
    EVoyageCrewCreateMethod[EVoyageCrewCreateMethod["Teleport"] = 1] = "Teleport";
})(EVoyageCrewCreateMethod = exports.EVoyageCrewCreateMethod || (exports.EVoyageCrewCreateMethod = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewCreate;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.type);
    messageWriter_sidecar_1.messageWriter.write16(m, d.heroType);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.enemyType);
    messageWriter_sidecar_1.messageWriter.write16(m, d.team);
    messageWriter_sidecar_1.messageWriter.write16(m, d.i);
    messageWriter_sidecar_1.messageWriter.write16(m, d.j);
    messageWriter_sidecar_1.messageWriter.write8(m, d.method);
    messageWriter_sidecar_1.messageWriter.write16(m, d.energy);
    messageWriter_sidecar_1.messageWriter.write16(m, d.hitpoints);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.name || '');
    messageWriter_sidecar_1.messageWriter.writeString(m, d.title || '');
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        type: messageWriter_sidecar_1.messageWriter.read16(m),
        heroType: messageWriter_sidecar_1.messageWriter.read16(m),
        enemyType: messageWriter_sidecar_1.messageWriter.readString(m),
        team: messageWriter_sidecar_1.messageWriter.read16(m),
        i: messageWriter_sidecar_1.messageWriter.read16(m),
        j: messageWriter_sidecar_1.messageWriter.read16(m),
        method: messageWriter_sidecar_1.messageWriter.read8(m),
        energy: messageWriter_sidecar_1.messageWriter.read16(m),
        hitpoints: messageWriter_sidecar_1.messageWriter.read16(m),
        name: messageWriter_sidecar_1.messageWriter.readString(m),
        title: messageWriter_sidecar_1.messageWriter.readString(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        type: 5,
        heroType: 6,
        enemyType: 'goblin-warrior',
        team: 1,
        i: 7,
        j: 8,
        method: EVoyageCrewCreateMethod.Teleport,
        energy: 333,
        hitpoints: 90,
        name: 'test',
        title: 'capin',
    };
    messageWriter_sidecar_1.messageWriter.test('crew-create', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    var cr = diveCrew_sidecar_1.diveCrew.findByIdSafe(msg.crewId);
    assert_sidecar_1.assert.nil(cr, 'oh no crew already exists');
    cr = diveCrew_sidecar_1.diveCrew.create(msg.type, msg.heroType, msg.enemyType, msg.team);
    cr.id = msg.crewId;
    cr.energy = msg.energy;
    // cr.hitpoints = msg.hitpoints
    if (msg.name) {
        cr.name = msg.name;
    }
    if (msg.title) {
        cr.title = msg.title;
    }
    diveCrew_sidecar_1.diveCrew.moveToIIJ(cr, msg);
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        if (cr.type === diveCrew_1.EVoyageCrewType.Hero) {
            // if (cr.crewState && cr.crewState.body) {
            //   // Set our body too
            //   let b = cr.crewState.body
            //   voyageMessageCrewStyle.sendMessageAndImmediatelyExecute({
            //     crewId: cr.id,
            //     body: b.body.idx,
            //     hair: b.hair.idx,
            //     head: b.head.idx,
            //     bodyColor: b.bodyColor,
            //     hairColor: b.hairColor,
            //     headColor: b.headColor,
            //   })
            // }
        }
        // if (cr.type === EVoyageCrewType.Alien) {
        //   let alien = diveCrew.create(EVoyageCrewType.Alien, 1)
        //   diveCrew.moveToIJ(alien, msg)
        // }
    }
    if (msg.method === EVoyageCrewCreateMethod.Teleport) {
        voyageSounds_sidecar_1.voyageSounds.playTeleport();
        voyageParticles_sidecar_1.voyageParticles.createMultiple('teleport', cr.x, cr.y + 16, 18);
    }
    // let alien = diveCrew.create(EVoyageCrewType.Alien, 1)
    // diveCrew.moveToIJ(alien, fl)
    // voyageSounds.playTeleport()
    //
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    // TODO: fix this
    // websockets._sendMessageAndImmediatelyExecute(write, msg)
    sendToAll(msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendToAll = sendToAll;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
